import { useEffect } from "react"
import SectionSlider3 from "../../sections/home/index3/section-slider3"
import SectionWhyChooseUs3 from "../../sections/home/index3/section-why-choose-us3"
import SectionWhatWeDo2 from "../../sections/home/index3/section-what-we-do2"
import SectionEstimation3 from "../../sections/home/index3/section-estimation3"
import SectionServices3 from "../../sections/home/index3/section-services3"
import SectionTestimonials3 from "../../sections/home/index3/section-testimonials3"
import SectionCompanyApproach2 from "../../sections/home/index3/section-company-approach2"
import SectionBooking1 from "../../sections/home/index/section-booking1"
import SectionBlogs3 from "../../sections/home/index3/section-blogs3"
import { data } from "../../../globals/data/home3";
import { loadScript } from "../../../globals/constants"
import SectionCompanyApproch1 from "../../sections/home/index/section-company-approch1"
import SectionVehicle3 from "../../sections/home/index3/section-vehicles3"
import SectionTrackk from "../../sections/home/index3/section-trackk"
import SectionOnDemand from "../../sections/home/index3/section-ondemand"
import YouTubeVideo from "../../sections/home/index3/youtube-video"

function Home3Page() {

    useEffect(() => {
        loadScript("/assets/js/custom.js", true)
    })

    return (
        <>
            <SectionSlider3 />
            <YouTubeVideo link="https://www.youtube.com/watch?v=97Y4XIPhciM"            />
            <SectionVehicle3 _data={data.vehicles} />
            <SectionEstimation3 _data={data.estimation} />
            <SectionWhyChooseUs3 _data={data.whychooseus} />
            {/* <SectionWhatWeDo2 _data={data.whatwedo} /> */}
            {/* <SectionCompanyApproch1 _data={data.approach} /> */}
            <SectionTrackk _data={data.trackk} />
            <SectionOnDemand _data={data.ondemand} />
            <SectionServices3 _data={data.services} />
            <SectionCompanyApproach2 _data={data.approch} />
            <SectionTestimonials3 _data={data.testimonials} />
            {/* <SectionBooking1 _data={data.booking} /> */}
            {/* <SectionBlogs3 _data={data.blogs} /> */}
        </>
    )
}

export default Home3Page;
